<template>
  <div class="field__error" v-if="errorMessage">{{ errorMessage }}</div>
</template>
<script>
  export default {
    name: 'ListErrorMessage',
    props: {
      errorMessage: String,
    },
  }
</script>
